import React from 'react';
import { SCREEN_TIME } from '../lib/content';
import { Reveal } from './Reveal';
export function ScreenTime() {
  return <section className="w-full bg-[#0F2A55] py-12 sm:py-20" data-id="element-500" data-mp="1yye381iosgjo">
      <div className="mx-auto w-full max-w-4xl px-4 text-center sm:px-8" data-id="element-501" data-mp="23qnqtawbx4is">
        <Reveal data-id="element-502" data-mp="23srqthr3xjds">
          <h2 className="font-display text-[32px] font-black leading-[1] tracking-tight text-white sm:text-6xl md:text-[5rem]" data-id="element-503" data-mp="28p8r1abkzo78">
            {SCREEN_TIME.title}
            <br data-id="element-504" data-mp="1b3kumpf4l5vp" />
            <span className="text-[#FF8C22]" data-id="element-505" data-mp="1b42yo8814oe6">{SCREEN_TIME.titleHighlight}</span>
          </h2>
          
          <p className="mx-auto mt-4 max-w-2xl text-[13px] font-bold leading-snug text-white sm:text-xl" data-id="element-506" data-mp="1g2nyi6jdd623">
            {SCREEN_TIME.description}
          </p>

          <div className="mx-auto mt-6 max-w-3xl overflow-hidden rounded-[24px] border-[3px] border-white bg-white sm:mt-10" data-id="element-507" data-mp="1p2aqk1q7kzih">
            <img src="https://cdn.magicpatterns.com/uploads/4A1vjguSL5BP6BkP53fpop/ChatGPT_Image_26_jul_2026,_23_05_22.webp" alt="Antes y después: de aburrirse con el celular a crear un robot" className="w-full object-cover rounded-[20px]" data-id="element-508" data-mp="2wh5p7ym3yhpv" />
          </div>

          <div className="mt-4 grid grid-cols-4 gap-1.5 sm:mt-8 sm:gap-4" data-id="element-509" data-mp="2zrj1xur5hn7u">
            {SCREEN_TIME.benefits.map((benefit, i) => <div key={i} className="flex flex-col items-center justify-center gap-1 rounded-xl border border-white/30 bg-white/10 p-2 text-center sm:p-4" data-id="element-510" data-mp="2uplcujw2jy6z" data-mpi={i}>
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white text-[11px] shadow-sm sm:h-12 sm:w-12 sm:text-2xl" data-id="element-511" data-mp="2lqzxsypt31ay">
                  {benefit.emoji}
                </span>
                <p className="font-display text-[7px] font-bold leading-tight text-white sm:text-sm" data-id="element-512" data-mp="2c1yeoznys3sr">
                  {benefit.text}
                </p>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}